import styled, { css } from 'styled-components';
import Icon from 'desktop/components/Icon';
import Text from 'desktop/components/Text';
import { colorVariables, mediaTemplates } from 'desktop/theme/variables';
import { ReactComponent as ArrowIcon } from 'desktop/assets/icons/arrow-thin-left.svg';

export const StyledArrowIcon = styled(ArrowIcon)`
  position: absolute;
  top: -2px;
  left: -35px;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: transform 0ms ease-in-out, fill 135ms ease-in-out;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    transition: 0ms ease-out;
  }
  ${(props) => `
    width: ${props.size}px;
    height: ${props.size}px;
  `}
  fill: ${colorVariables.white}
`;

export const StyledIcon = styled(Icon)`
  position: absolute;
  top: -2px;
  left: -35px;
  transform: rotate(-90deg);
  transform-origin: center;
  transition: transform 0ms ease-in-out, fill 135ms ease-in-out;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    transition: 0ms ease-out;
  }
`;

export const StyledText = styled(Text)`
  letter-spacing: 1px;
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    transition: 0ms ease-out;
  }
`;

export const ProgramsButtonWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 1;
  padding-top: 130px;
  transition: opacity 175ms ease-in-out;
  z-index: 1;
`;

export const ChannelsSideButton = styled.div`
  transform: rotate(90deg) translate(0, 40px);
  height: 30px;
  width: 130px;
`;

export const ProgramsSideButton = styled.div`
  transform: rotate(90deg) translate(0, 40px);
  height: 30px;
  width: 130px;
`;

export const ChannelsButtonWrap = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  opacity: 0;
  padding-top: 130px;
  transition: opacity 175ms ease-in-out;
  z-index: 1;
`;

export const EpgStyled = styled.div`
  position: fixed;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  background-color: black;
  width: 100%;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1100;
  transform: translateX(100%) translateX(-403px);
  @supports (-ms-ime-align: auto) {
    transform: translateX(100%) translateX(-403px) translateZ(1px);
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    transform: translateX(100%) translateX(-403px) translateZ(1px);
  }
  transition: transform 175ms linear;

  ${(props) =>
    !props.hovered &&
    !props.expanded &&
    css`
      ${mediaTemplates.s} {
        transform: translateX(100%);
        @supports (-ms-ime-align: auto) {
          transform: translateX(100%) translateZ(1px);
        }
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          transform: translateX(100%) translateZ(1px);
        }
      }
    `};

  ${(props) =>
    props.fullscreen &&
    css`
      position: absolute;
      z-index: 1080;
      transform: translateX(100%);
      @supports (-ms-ime-align: auto) {
        transform: translateX(100%) translateZ(1px);
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        transform: translateX(100%) translateZ(1px);
      }

      &:hover {
        transform: translateX(100%) translateX(-403px);
        @supports (-ms-ime-align: auto) {
          transform: translateX(100%) translateX(-403px) translateZ(1px);
        }
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          transform: translateX(100%) translateX(-403px) translateZ(1px);
        }
        //transition: transform 235ms ease-out;
      }
    `};
  ${(props) =>
    props.expanded &&
    css`
      transform: translateX(0);
      @supports (-ms-ime-align: auto) {
        transform: translateX(0) translateZ(1px);
      }
      @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
        transform: translateX(0) translateZ(1px);
      }
      transition: transform 315ms ease-out;
      z-index: 1090;

      &:hover {
        transform: translateX(0);
        @supports (-ms-ime-align: auto) {
          transform: translateX(0) translateZ(1px);
        }
        @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
          transform: translateX(0) translateZ(1px);
        }
      }
    `};
`;

export const ProgramButton = styled.div`
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  width: 60px;
  display: flex;
  justify-content: center;
  background-color: black;
  padding-top: 20px;
  cursor: pointer;
  transition: 0.5s ease-in;
  z-index: 1101;
  @supports (-ms-ime-align: auto) {
    transform: translateZ(2px);
  }
  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    transform: translateZ(2px);
  }

  ${(props) =>
    !props.hovered && !props.visibleFullScreenControls && props.fullscreen && !props.expanded
      ? css`
          opacity: 0;
          visibility: hidden;
        `
      : css`
          opacity: 1;
          visibility: visible;
        `};

  ${(props) =>
    props.expanded &&
    css`
      ${ProgramsSideButton} {
        ${StyledArrowIcon} {
          transform: rotate(90deg);
        }
      }
    `};

  ${(props) =>
    props.fullscreen &&
    css`
      position: absolute;
    `};

  ${(props) =>
    props.fullscreen &&
    !props.expanded &&
    css`
      background-color: rgba(0, 0, 0, 0.75);
      z-index: 1081;

      ${ChannelsButtonWrap} {
        opacity: 1;
      }
      ${ProgramsButtonWrap} {
        opacity: 0;
      }
    `};

  ${(props) =>
    props.fullscreen &&
    props.hovered &&
    css`
      background-color: rgba(0, 0, 0, 1);

      ${ChannelsButtonWrap} {
        opacity: 0;
      }
      ${ProgramsButtonWrap} {
        opacity: 1;
      }
    `};

  ${(props) =>
    props.hovered &&
    css`
      ${mediaTemplates.s} {
        ${ChannelsButtonWrap} {
          opacity: 0;
        }
        ${ProgramsButtonWrap} {
          opacity: 1;
        }
      }
    `};

  ${(props) =>
    props.hovered &&
    !props.expanded &&
    css`
      ${mediaTemplates.s} {
        & ~ ${EpgStyled} {
          transform: translateX(100%) translateX(-403px);
          @supports (-ms-ime-align: auto) {
            transform: translateX(100%) translateX(-403px) translateZ(1px);
          }
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transform: translateX(100%) translateX(-403px) translateZ(1px);
          }
          transition: transform 235ms ease-out;
        }
      }
    `};

  ${(props) =>
    !props.expanded &&
    css`
      ${mediaTemplates.s} {
        ${ChannelsButtonWrap} {
          opacity: 1;
        }
        ${ProgramsButtonWrap} {
          opacity: 0;
        }
      }
    `};

  ${(props) =>
    props.hovered &&
    !props.expanded &&
    css`
      ${mediaTemplates.s} {
        & ~ ${EpgStyled} {
          transform: translateX(100%) translateX(-403px);
          @supports (-ms-ime-align: auto) {
            transform: translateX(100%) translateX(-403px) translateZ(1px);
          }
          @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
            transform: translateX(100%) translateX(-403px) translateZ(1px);
          }
          transition: transform 235ms ease-out;
        }
      }
    `};

  &:hover {
    background-color: ${colorVariables.gray_cod};
    transition: 135ms ease-out;

    & ~ {
      ${(props) =>
        props.fullscreen &&
        css`
          ${EpgStyled} {
            transform: translateX(100%) translateX(-403px);
            @supports (-ms-ime-align: auto) {
              transform: translateX(100%) translateX(-403px) translateZ(1px);
            }
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
              transform: translateX(100%) translateX(-403px) translateZ(1px);
            }
            transition: transform 235ms ease-out;
          }
        `};
      ${(props) =>
        props.expanded &&
        css`
          ${EpgStyled} {
            transform: translateX(0);
            @supports (-ms-ime-align: auto) {
              transform: translateX(0) translateZ(1px);
            }
            @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
              transform: translateX(0) translateZ(1px);
            }
          }
        `};
    }

    ${ChannelsButtonWrap} {
      opacity: 0;
    }
    ${ProgramsButtonWrap} {
      opacity: 1;
    }
    ${ChannelsSideButton} {
      ${StyledText} {
        color: ${colorVariables.fire};
      }
      ${StyledIcon} {
        fill: ${colorVariables.fire};
      }
    }
    ${ProgramsSideButton} {
      ${StyledArrowIcon} path {
        fill: ${colorVariables.fire};
      }
      ${StyledText} {
        color: ${colorVariables.fire};
      }
    }
  }
`;
